import './tailwind.scss'; // needs to be imported before primereact or else it overrides button type bg transparency
import '@aws-amplify/ui-react/styles.css'; // needs to be imported before primereact or else it overrides font family
import 'primereact/resources/themes/lara-light-blue/theme.css'; //theme
import 'primereact/resources/primereact.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import '/node_modules/primeflex/primeflex.css'; //flex
import './index.scss';
import './assets/style.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from '@mezzodevelopment/mezzo-ui/auth';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
    <AuthProvider
      config={{
        baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.teammezzo.com',
        redirectUri: '/auth/callback',
        loginRedirectRoute: '/dashboard',
        logoutRedirectRoute: '/login',
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
    </PrimeReactProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
